import React, { useEffect, useRef, useState } from "react";
import Modal from 'react-bootstrap/Modal';

import '../../css/modal.css';
import Attention from "../ReusableComponents/Attention";
import { Form, FormControl as Input, InputGroup, Button, Select, Spinner } from "react-bootstrap";
import DefaultButton from "../ReusableComponents/DefaultButton";
import { RiCloseFill } from "react-icons/ri";
import { MdDelete } from "react-icons/md";
import { usePreferences } from "../../contexts/PreferencesContext";
import TableEmptyState from '../ReusableComponents/TableEmptyState';

const ModalDemanda = (props) => {
  const { processo_name, showModal, setShowModal, categoria, professores_all, OnFinish } = props;
  const { t } = usePreferences();
  const [professores_selecionadas, setprofessoresSelecionadas] = useState({});
  const [selectprofessor, setSelectprofessor] = useState('');
  const [descritivo, setDescritivo] = useState('');
  const [msgErro, setMsgErro] = useState('');


  const [professores_total, setprofessoresTotal] = useState({});

  useEffect(() => {
    if (categoria != null && categoria.professores != undefined) {
      let professores_selecionadas_ = {};
      for (let i = 0; i < categoria.professores.length; i++) {
        professores_selecionadas_[categoria.professores[i].id] = categoria.professores[i];
      }
      setprofessoresSelecionadas(professores_selecionadas_);
      setDescritivo(categoria.descritivo ?? '');
    }
  }, [categoria]);


  useEffect(() => {

    let professores_total_ = {};
    for (let i = 0; i < professores_all.length; i++) {
      professores_total_[professores_all[i].id] = professores_all[i];
    }
    setprofessoresTotal(professores_total_);

  }, []);

  const number_questoes = new Array(101).fill(0);
  console.log(number_questoes);


  return (
    categoria != null && <Modal
      show={showModal == true}
      dialogClassName="modal_width"
      onHide={() => {
        setShowModal(false);
        setprofessoresSelecionadas({});
      }}>

            <Modal.Header closeButton closeLabel=''><Modal.Title><span>{t('label_subject')}</span>{' '}<span>{categoria.name}</span><br />
            </Modal.Title></Modal.Header>
            <Modal.Body>
            {msgErro != '' && <div style={{ display: 'flex', marginBottom: 15, width: '100%' }}>
                                    <div className="badge badge-danger error-message-badge error-message-badge-dismissible w-100" role="alert">
                                        <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => setMsgErro('')}></button>


                                        <p style={{ marginBottom: 0, whiteSpace: 'pre' }}>{msgErro}</p>

                                    </div>
                                    <br />

                                </div>}
                                <p>{t('desc_select_authors_subject')}</p>

                <InputGroup>

                    <div className="flex fdcolumn flex1 margin-bottom">
                        <Form.Label>{t('label_descriptive')} <Attention /></Form.Label>
                        <Input
              placeholder={t('label_descriptive')}
              value={descritivo}
              onChange={(e) => setDescritivo(e.target.value)}
              required
              as="textarea" />

                    </div>
                </InputGroup>


                <InputGroup>
                    <div className="flex fdcolumn flex1 margin-bottom">
                        <Form.Label>{t('authors')} <Attention /></Form.Label>
                        <select className="form-select " onChange={(e) => {
              if (e.target.value != '') {
                let professores_selecionadas_ = { ...professores_selecionadas };
                let professores = { ...professores_total };
                delete professores[e.target.value];
                professores_selecionadas_[e.target.value] = { ...professores_total[e.target.value] };
                professores_selecionadas_[e.target.value].numero_questoes = '';
                professores_selecionadas_[e.target.value].numero_questoes_dissertativas = '';

                setprofessoresSelecionadas(professores_selecionadas_);
                setprofessoresTotal(professores);
              }
            }} value={selectprofessor}>
                            <option value="">{t('desc_select_authors_subject')}</option>
                            {Object.values(professores_total).sort((a, b) => a.name - b.name).map((value, index) =>
              <option
                key={index}
                value={value["id"]}>
                {value["name"]} - {value["email"]}</option>
              )}
                        </select>
                        {/* <a onClick={()=>{
                 let professores_selecionadas_ = { ...professores_selecionadas };
                 Object.values(professores_total).map((value, index) => {
                     professores_selecionadas_[value.id]=value;
                 })
                 setprofessoresSelecionadas(professores_selecionadas_);
                 setprofessoresTotal({});
              }} style={{textAlign:'right',fontSize:15,marginTop:10,cursor:'pointer',textDecoration:'none'}} className="link-success">Selecionar todos as professores</a> */
            }

                    </div>
                </InputGroup>

                <InputGroup>

                    <div className="flex fdcolumn flex1 margin-bottom">
                        <div className="table-modern-card">
                            <div className="table-modern-scroll mb-0">
                                <table id="tech-companies-1" className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>{t('label_name')}</th>
                                            <th>{t("label_email")}</th>
                                            <th>{t('label_objective_question_count')}</th>
                                            <th>{t('label_essay_question_count')}</th>



                                            <th data-priority="3">{t('label_actions')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Object.values(professores_selecionadas).sort((a, b) => a.created_at - b.created_at).map((item, id) =>
                    <tr key={id}>
                                                <td>{item.name}</td>
                                                <td>{item.email}</td>
                                                <td>
                                                    <select className="form-select " onChange={(e) => {
                          let professores = { ...professores_selecionadas };
                          professores[item.id].numero_questoes = e.target.value;
                          setprofessoresSelecionadas(professores);
                        }} value={item.numero_questoes}>
                                                        <option

                            value={''}>
                            {t('value_not_specified')}</option>
                                                        {number_questoes.map((value, index) =>
                          <option
                            key={index}
                            value={index}>
                            {index}</option>
                          )}
                                                    </select>

                                                </td>

                                                <td>
                                                    <select className="form-select " onChange={(e) => {
                          let professores = { ...professores_selecionadas };
                          professores[item.id].numero_questoes_dissertativas = e.target.value;
                          setprofessoresSelecionadas(professores);
                        }} value={item.numero_questoes_dissertativas}>
                                                        <option

                            value={''}>
                            {t('value_not_specified')}</option>
                                                        {number_questoes.map((value, index) =>
                          <option
                            key={index}
                            value={index}>
                            {index}</option>
                          )}
                                                    </select>

                                                </td>


                                                <td>
                                                    <div className="actions-group">
                                                    <span
                          onClick={(e) => {
                            let professores = { ...professores_total };
                            professores[item.id] = { ...professores_selecionadas[item.id] };

                            let professores_selecionadas_ = { ...professores_selecionadas };
                            delete professores_selecionadas_[item.id];

                            setprofessoresSelecionadas(professores_selecionadas_);
                            setprofessoresTotal(professores);
                          }}
                          className="inline-flex align-center jcc bg-danger icon"
                          style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                          title={t("legacy_deletar_elaborador")}>

                                                        <MdDelete size={17} color="white" />
                                                    </span>

                                                    </div>
                                                    </td>

                                            </tr>
                    )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        {Object.values(professores_selecionadas).length == 0 && <div className="row">
                            <div className="col-12">
                                <TableEmptyState title={t('empty_no_author_selected')} icon="📋" />

                            </div>
                        </div>}
                    </div>

                </InputGroup>


                {<div className="w100 inline-flex jcsb margin-top-1">
                    {/* <Link to={`/accounts/list`}>
                           <Button variant="secondary"><RiArrowGoBackLine/> Voltar</Button>
                       </Link> */}
                    <DefaultButton
            bg="secondary"
            text={t('action_close')}
            icon={<RiCloseFill />}
            onClick={() => {
              setShowModal(false);
              setprofessoresSelecionadas({});
            }} />

                    {/* <Button variant="success" type="submit" disabled={this.loading}>
                           {this.state.loading ? <Spinner /> : ""}
                           Registrar usuário
                       </Button> */}
                    <DefaultButton
            type="button"
            disabled={Object.values(professores_selecionadas).length == 0}

            onClick={() => {
              if (descritivo.trim().length == 0) {
                setMsgErro(t('validation_required_field').replace('{field}', t('label_descriptive')));
                return;
              }

              OnFinish(Object.values({ ...professores_selecionadas }).sort((a, b) => a.created_at - b.created_at), categoria, descritivo);
              setShowModal(false);

              setprofessoresSelecionadas({});
              setDescritivo('');
              setMsgErro('');


            }}
            bg={Object.values(professores_selecionadas).length > 0 ? "confirm" : "secondary"}
            text={t('action_save')} />

                </div>}

            </Modal.Body>
        </Modal>);


};

export default ModalDemanda;
